import React from 'react';
import { Link } from 'react-router-dom';
import { logoAztecaWebp, logoCuadradoWebp } from '../../assets/icons';

const Footer = () => {
  return (
    <footer className="w-full bg-white border-t border-border-subtle py-16 sm:py-20">
      <div className="max-w-[1680px] mx-auto px-6 sm:px-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 pb-12 border-b border-border-subtle">
          {/* Logo - Responsive */}
          <Link to="/" className="inline-block">
            <img 
              alt="JCB AZTECA" 
              className="h-8 w-auto object-contain hidden sm:block" 
              src={logoAztecaWebp}
            />
            <img 
              alt="JCB AZTECA" 
              className="h-8 w-auto object-contain sm:hidden" 
              src={logoCuadradoWebp}
            />
          </Link>
          
          {/* Navigation Links */}
          <div className="flex flex-wrap items-center gap-x-8 gap-y-4">
            <Link to="/" className="font-display text-xs uppercase tracking-luxury text-text-muted hover:text-dark-primary transition-colors">
              Inicio
            </Link>
            <Link to="/machinery" className="font-display text-xs uppercase tracking-luxury text-text-muted hover:text-dark-primary transition-colors">
              Maquinaria
            </Link>
            <Link to="/spare-parts" className="font-display text-xs uppercase tracking-luxury text-text-muted hover:text-dark-primary transition-colors">
              Refacciones
            </Link>
            <Link to="/services" className="font-display text-xs uppercase tracking-luxury text-text-muted hover:text-dark-primary transition-colors">
              Servicios
            </Link>
            <Link to="/about" className="font-display text-xs uppercase tracking-luxury text-text-muted hover:text-dark-primary transition-colors">
              Nosotros
            </Link>
            <Link to="/contact" className="font-display text-xs uppercase tracking-luxury text-text-muted hover:text-dark-primary transition-colors">
              Contacto
            </Link>
          </div>
          
          {/* Social Media Links */}
          <div className="flex items-center space-x-4 text-xs text-text-muted font-display uppercase tracking-luxury">
            <a 
              href="https://www.instagram.com/jcbazteca.mx/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-dark-primary transition-colors"
            >
              Instagram
            </a>
            <span className="text-border-subtle">/</span>
            <a 
              href="https://www.facebook.com/jcbaztecamx" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-dark-primary transition-colors"
            >
              Facebook
            </a>
            <span className="text-border-subtle">/</span>
            <a 
              href="https://www.youtube.com/@jcbaztecamx" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-dark-primary transition-colors"
            >
              YouTube
            </a>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-text-subtle gap-4">
          <p>© 2026 JCB AZTECA S.A. de C.V. Todos los derechos reservados.</p>
          <div className="flex items-center space-x-6">
            <Link to="/privacy-policy" className="hover:text-dark-primary transition-colors">Aviso de Privacidad</Link>
            <Link to="/terms-conditions" className="hover:text-dark-primary transition-colors">Términos y Condiciones</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;